<template>
  <div class="content">

  </div>
</template>

<script>
export default {
  name: "Notifications"
};
</script>

<style scoped>

</style>
